import "@/services/config/translation";
import "react-toastify/dist/ReactToastify.css";
import "viem/window";
import { Buffer } from "buffer";

import WebApp from "@twa-dev/sdk";
import { H } from "highlight.run";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./routes";

WebApp.ready();
WebApp.expand();

H.init("jdk50x7d", {
  serviceName: "frontend-app",
  tracingOrigins: true,
  networkRecording: {
    enabled: true,
    recordHeadersAndBody: true,
  },
});

globalThis.Buffer = Buffer;
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
